import { useDispatch, useSelector } from "react-redux";
import { addModal, deleteModal, resetModals } from "./actions";
import { getOpenedModals } from "./selectors";

export default function useModal() {
	const dispatch = useDispatch();
	const openedModals = useSelector(getOpenedModals);

	const openedModalsExist = openedModals.length !== 0;

	const onOpenModal = (key) => {
		dispatch(addModal(key));
	};

	const onCloseModal = (key) => {
		dispatch(deleteModal(key));
	};

	const clearModals = () => {
		dispatch(resetModals());
	};

	return {
		openedModals,
		openedModalsExist,
		onOpenModal,
		onCloseModal,
		clearModals,
	};
}
